import { SectionTitle } from "@/components/molecules";
import { PageContainer } from "@/components/organisms";
import InfoItem from "@/containers/OrderContainer/Common/InfoItem";
import {capitalizeFirst} from '@/helpers/shadcn/utils'

const Section = ({id, title}) => {
  return <SectionTitle id={id} label={title} />
}

const DisplayInformation = ({orderDetails}) => {
  const sections = [
    {
      id: 'dates',
      title: 'Dates',
      items: [
        {label: 'Order Date', value: orderDetails?.orderDate},
        {label: 'Delivery Date', value: orderDetails?.deliveryDate},
      ],
    },
    {
      id: 'identification_details',
      title: 'Identification Details',
      items: [
        {label: 'Acknowledgent Status', value: capitalizeFirst(orderDetails?.acknowledgementStatus)},
        {label: 'Acknowledgment Processing Status', value: orderDetails?.acknowledgementProcessingStatus},
        {label: 'Acknowledgement Sub Status', value: capitalizeFirst(orderDetails?.acknowledgementSubStatus)},
        {label: 'Source Invoice ID', value: orderDetails?.sourceInvoiceId},
        {label: 'Alternate Order ID', value: orderDetails?.alternateOrderId},
        {label: 'Market Place Order ID', value: orderDetails?.marketPlaceOrderId},
        {label: 'Sold Customer ID', value: orderDetails?.soldCustomerId},
        {label: 'Order Type', value: capitalizeFirst(orderDetails?.orderType)},
        {label: 'Payment Terms Code', value: orderDetails?.paymentTermsCode},
        {label: 'Order Payment Status', value: orderDetails?.orderPaymentStatus},
      ],
    },
    {
      id: 'order_status_and_details',
      title: 'Order Processing and Details',
      items: [
        {label: 'Invoice Download', value: orderDetails?.invoiceDownload},
        {label: 'Route ID', value: orderDetails?.routeId},
        {label: 'Route Type ID', value: orderDetails?.routeTypeId},
        {label: 'Route Sales Rep WorkForce ID', value: orderDetails?.routeSalesRepWorkForceId},
      ],
      mainItem: {label: 'Reason Description', value: orderDetails?.reasonDescription},
    },
  ]

  return (
    <>
      {sections.map(section => (
        <div key={section.id} className="order-overview">
          <div className="sc-border grid pl-4">
            <Section id={section.id} title={section.title} />
          </div>
          {section.mainItem && (
            <div className="grid pb-6 pl-4">
              <InfoItem label={section.mainItem.label} value={section.mainItem.value} />
            </div>
          )}
          <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
            {section.items.map(item => (
              <InfoItem key={item.label} label={item.label} value={item.value} />
            ))}
          </div>
        </div>
      ))}
    </>
  )
}

const OfflineOrderInfo = ({ OrderDetails }) => {
  return (
    <PageContainer>
      <DisplayInformation orderDetails={OrderDetails} />
    </PageContainer>
  );
};

export default OfflineOrderInfo;